
import React from 'react';

interface StarIconProps extends React.SVGProps<SVGSVGElement> {}

const StarIconEmpty: React.FC<StarIconProps> = (props) => (
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24" 
    strokeWidth={1.5} 
    stroke="currentColor" 
    {...props}
  >
    <path 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.479.038.676.646.314.956l-4.24 3.585a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.822.672l-4.922-3.03a.563.563 0 0 0-.63 0l-4.922 3.03a.563.563 0 0 1-.823-.672l1.285-5.385a.563.563 0 0 0-.182-.557l-4.24-3.585a.563.563 0 0 1 .314-.956l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" 
    />
  </svg>
);

export default StarIconEmpty;